<div class="maplibre-realtime-container">
  <div *ngIf="liveOption?.enabled" class="nodes-current-date">{{ currentDisplayedTime }}</div>

  <div class="map-view-control">
    <select
      class="map-view-select"
      [(ngModel)]="mapViewMode"
      (ngModelChange)="onMapViewChange($event)"
    >
      <option *ngFor="let mode of mapViewModes; trackBy: trackByIndex" [value]="mode.value">
        {{ mode.label | translate }}
      </option>
    </select>
  </div>

  <app-extended-map-options
    class="extended-map-options-host"
    (showNodesEvent)="onShowNodesChange($event)"
    (showWindDirEvent)="onShowWindDirChange($event)"
    (zoneRiskType)="onZoneRiskTypeChange($event)"
    (showAirNowSensorsEvent)="showAirNowSensors($event)"
  ></app-extended-map-options>

  <div class="mapping-group-select-container" *ngIf="activePlayOption && zonesList.length">
    <select [(ngModel)]="selectedZoneId" (ngModelChange)="onZoneChange()">
      <option *ngFor="let zone of zonesList; trackBy: trackById" [value]="zone.id">
        {{ zone.name }}
      </option>
    </select>
  </div>

  <div *ngIf="showFloors && floorLevels.length > 1" class="floor-level-container">
    <ul>
      <li
        *ngFor="let level of floorLevels; trackBy: trackByIndex"
        (click)="changeFloorLevel(level)"
        [class.selected]="selectedFloorLevel === level.floor"
      >
        {{ level.floor }}
      </li>
    </ul>
  </div>

  <div *ngIf="loading || !mapVisible" class="spinner-outer">
    <div class="spinner-cover">
      <div class="spinner-section">
        <mat-progress-spinner
          [color]="spinnerColor"
          [diameter]="spinnerDiameter"
          [mode]="spinnerMode"
          [strokeWidth]="spinnerStrokeWidth"
          [value]="spinnerValue"
        ></mat-progress-spinner>
      </div>
    </div>
  </div>

  <div
    #mapContainer
    id="maplibre-realtime"
    class="maplibre-map"
    [class.maplibre-map-hidden]="!mapVisible"
  ></div>
</div>

<div class="video-progressbar-wrap d-flex" *ngIf="showPlayOption && !loading">
  <span class="control-btn" (click)="startPlay()">
    <span class="material-symbols-outlined">{{ isPlaying ? 'pause' : 'play_arrow' }}</span>
  </span>
  <div class="progress" [class.scrollable]="dustLayer.length > 30" *ngIf="dustLayer.length">
    <ng-container *ngFor="let value of dustLayer; let i = index; trackBy: trackByIndex">
      <div
        class="progress-bar"
        role="progressbar"
        [style]="'width: calc(' + 100 / dustLayer.length + '% - 1px)'"
        [class.selected]="currentKmlIndex != null && i === currentKmlIndex"
        [class.overflowed]="dustLayer.length > 30"
        [attr.aria-valuenow]="'width: calc(' + 100 / dustLayer.length + '% - 1px)'"
        aria-valuemin="0"
        aria-valuemax="100"
        (click)="showKmlFile(i)"
      >
        <span class="progress-value">{{ value.currTime }}</span>
        <span *ngIf="i == 0 || value.currDate != dustLayer[i - 1].currDate" class="progress-date">{{
          value.currDate
        }}</span>
      </div>
    </ng-container>
  </div>
  <div class="date">
    <span>{{
      dustLayer[currentKmlIndex || 0].currDate + ' | ' + dustLayer[currentKmlIndex || 0].currTime
    }}</span>
  </div>
</div>
